import React from "react";
import BiodiversityLayerGroup from "../BiodiversityLayerGroup";

// import BiodiversityDashboard from "./Components/BiodiversityDashboard";
import { WmsLayer } from "../../layers/WmsLayer";
import { TreeCoverLayer } from "../../layers/TreeCoverLayer";
import Dashboard from "./Components/Dashboard";
import DefaultLayerGroup from "../DefaultLayerGroup";

class WaterSurfacesLayerGroup extends DefaultLayerGroup {
  constructor(map = null, layer_group_data) {
    super(map, layer_group_data);

    this.id = this.id.replace(
      layer_group_data.uuid,
      `water-surfaces-${layer_group_data.uuid}`
    );

    this.has_dashboard = true;
    this.dashboard = ({ lang }) => (
      <Dashboard lang={lang} layer_group_uuid={layer_group_data.uuid} />
    );

    this.layers = this.createLayers();
  }
}

export default WaterSurfacesLayerGroup;
